import React from 'react';
import { useFormState } from '@fiverr-private/forms';
import { Button } from '@fiverr-private/button';
import { fullWidthButton } from './FormSubmitButton.styles.ve.css';

interface Props {
    loading: boolean;
    children: React.ReactNode;
    fullWidth?: boolean;
}

export const FormSubmitButton = ({ loading, children, fullWidth = true }: Props) => {
    const { isValidating, isValid } = useFormState();

    return (
        <Button
            className={fullWidth ? fullWidthButton : ''}
            disabled={!isValid}
            loading={isValidating || loading}
            type="submit"
        >
            {children}
        </Button>
    );
};
